import React, { useState } from 'react'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import CustomFieldType from 'constants/CustomFieldTypes'
import { toDisplayDateTime } from 'utils/date'
import { ReadOnlyCheckbox } from 'components/Shared/ReadOnlyCheckbox'
import styles from './ReadOnlyCustomField.module.css'
import { CustomField } from 'components/CustomFields/CustomFieldsColumn/CustomField'

export function ReadOnlyCustomField ({ definition, entityId }) {
  const [value, setValue] = useState()

  const { type, translations, selectOptions, } = definition

  return <CustomField
    definition={definition}
    entityId={entityId}
    value={value}
    onValueChanged={setValue}
    renderField={getTranslation => {
      const label = getTranslation(translations)

      switch (type) {
        case CustomFieldType.Boolean:
          return <div className={styles.checkboxContainer}>
            <ReadOnlyCheckbox
              checked={value}
              label={label}/>
          </div>
        case CustomFieldType.Date:
          return <ReadOnlyTextField
            value={value}
            label={label}/>
        case CustomFieldType.DateTime:
          return <ReadOnlyTextField
            value={value && toDisplayDateTime(value)}
            label={label}/>
        case CustomFieldType.Text:
          return <ReadOnlyTextField
            value={value}
            label={label}/>
        case CustomFieldType.Select:
          const selectedOption = selectOptions?.find(option => option.id === value)
          return <ReadOnlyTextField
            value={selectedOption && getTranslation(selectedOption.translations)}
            label={label}/>
        default:
          return <></>
      }
    }}/>
}
